/* eslint-disable no-async-promise-executor */
import { AudioOutlined, InfoCircleOutlined, WarningOutlined } from '@ant-design/icons';
import { Button, Card, Col, Popconfirm, Row, Skeleton, Switch, Tooltip } from 'antd';
import { message } from '../utils/messageWithScroll';
import { ActiveConsumer } from 'contexts/legacy/ActiveContext';
import { Bitrix24Consumer } from 'contexts/legacy/Bitrix24Context';
import { LanguageConsumer } from 'contexts/legacy/LanguageContext';
import { NumberConsumer } from 'contexts/legacy/NumberContext';
import { SystemConsumer } from 'contexts/legacy/SystemContext';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { api, dialogApi } from 'services/api';
import GoodHabitsAlert from './MessageCard/GoodHabitsAlert';
import SubscriptionWarning from './MessageCard/SubscriptionWarning';
import NumberSelectors from './MessageCard/NumberSelectors';
import TemplateLayout from './MessageCard/TemplateLayout';
import MessageLayout from './MessageCard/MessageLayout';

class MessageItem extends Component {
	constructor(props) {
		super(props);

		this.state = {
			msg: props.test ? props.language?.language?.test_message_prefill || '' : '',
			from: '',
			fromApi: '',
			to: '',
			files: [],
			infos: {
				domain: '',
				auth: '',
			},
			showTemplateLayout: false,
			showTemplateButtons: false,
			templateList: [],
			templateListError: null,
			selectedTemplateArray: [],
			headerVars: [],
			buttonsVars: [],
			selectedTemplate: {},
			paramsCount: 0,
			recording: false,
			listening: false,
			recordButton: <AudioOutlined />,
			recordedBlob: null,
			voice_recording: null,
			recordingButtonAnimation: 'none',
			listeningButtonAnimation: 'none',
			registerOnChat: false,
			recordingButtonFontSize: '1.5em',
			isToggleActived: false,
			validateNumberFormat: false,
			confirmSetNumberOnPattern: false,
			isFromBrazil: false,
			onlyNational: false,
			isChatExistsInEntity: false,
			loadingVerifyIfChatExistsInEntity: false,
			maxFileSize: false,
			userApp: null,
			closeAlert: 1,
			totalButtons: [],
		};
		this.updateState = this.updateState.bind(this);
	}

	updateState(updater, callback) {
		this.setState(updater, callback);
	}

	loadClientInfos(domain) {
		return new Promise(async (resolve, reject) => {
			this.setState({ loadingClient: true });

			const request = {
				action: 'getClient',
				domain,
			};

			await api.post('getClient', request).then(async (res) => {
				this.setState({ loadingClient: false });
				if (res.data.status) {
					this.setState({ infos: res.data.dados });
					resolve(res.data);
				} else {
					reject(res.data);
				}
			});
		});
	}

	async getTemplatesListMeta(token) {
		const request = {
			params: {
				token,
				domain: this.state.infos.domain,
			},
		};

		try {
			const result = await api.get('getTemplates', request);
			this.setState({ templateList: result.data });
		} catch (error) {
			this.setState({ templateList: [] });
			console.error('Error fetching template list:', error);
			const lang = this.props.language?.language;
			const errorCode = error.response?.data?.errorCode;
			const errorMessage =
				errorCode && lang && Object.prototype.hasOwnProperty.call(lang, errorCode)
					? lang[errorCode]
					: lang?.template_error || 'Error fetching templates';
			message.error(errorMessage);
		}
	}

	async getTemplateList(from, fromApi) {
		const http = fromApi === 'dialog' ? dialogApi : api;
		const action = fromApi === 'dialog' ? 'template/get-template-list' : 'getTemplateList';
		const data = {
			action,
			api: fromApi,
			sender: from,
			domain: this.state.infos.domain,
			auth: this.state.infos.auth,
		};

		const headers = {
			Domain: this.state.infos.domain,
			Number: from,
		};

		await http
			.post(action, data, { headers })
			.then(async (res) => {
				if (res.data.dados) {
					this.setState({ templateList: res.data.dados });
					if (res.data.dados.errors) {
						this.handleTemplateError();
					}
				} else {
					this.setState({ templateList: [] });
				}
			})
			.catch((error) => {
				this.setState({ templateList: [] });
				console.error('Error fetching template list:', error);
				const lang = this.props.language?.language;
				const errorCode = error.response?.data?.errorCode;
				const errorMessage =
					errorCode && lang && Object.prototype.hasOwnProperty.call(lang, errorCode)
						? lang[errorCode]
						: lang?.template_error || 'Error fetching templates';
				message.error(errorMessage);
			});
	}

	async checkMessagebirdConversationStatus() {
		const data = {
			action: 'getTemplateList',
			api: this.state.fromApi,
			sender: this.state.from,
			destination: this.state.to,
			domain: this.state.infos.domain,
			auth: this.state.infos.auth,
		};

		await api
			.post('getTemplateList', data)
			.then(async (res) => {
				this.setState({ templateList: res.data.dados });
			})
			.catch((error) => {
				this.setState({ templateList: [] });
				console.error('Error fetching template list:', error);
				const lang = this.props.language?.language;
				const errorCode = error.response?.data?.errorCode;
				const errorMessage =
					errorCode && lang && Object.prototype.hasOwnProperty.call(lang, errorCode)
						? lang[errorCode]
						: lang?.template_error || 'Error fetching templates';
				message.error(errorMessage);
			});
	}

	onChangeSwitch = () => {
		this.setState({ registerOnChat: !this.state.registerOnChat });
	};

	sendMsgHandler = async (e) => {
		if (this.state.validateNumberFormat && this.state.registerOnChat) {
			const isMissingNineRegex = /\+?\b5?5?\d{2}(\d{4}\d{4})\b/;
			const isBrazilianWithCCRegex = /\+?55\d{2}9?(\d{4}\d{4})/;

			const notFormatednumbers = this.state.to.filter((item) => {
				const isNationalOrHasBrCC = !!(
					this.state.onlyNational || item.match(isBrazilianWithCCRegex)
				);
				const isMissingNine = !!item.match(isMissingNineRegex);
				const isNationalAndIsMissingNine = isNationalOrHasBrCC && isMissingNine;

				return isNationalAndIsMissingNine;
			});

			if (notFormatednumbers.length > 0) {
				this.setState({ confirmSetNumberOnPattern: true });
			} else {
				this.sendMsg(e);
			}
		} else if (this.state.files.length > 0) {
			let verifyFileSize = false;
			this.state.files.forEach((file) => {
				if (file.size > 104857600) {
					verifyFileSize = true;
					message.error(this.props.language.warning_maximum_file_size);
				}
			});

			if (!verifyFileSize) this.sendMsg(e);
		} else {
			this.sendMsg(e);
		}
	};

	validatePhoneNumber = (number) => {
		const cleanNumber = number.replace(/\D/g, '');

		if (cleanNumber.length < 8 || cleanNumber.length > 15) {
			return false;
		}

		return /^\+?[1-9]\d{7,14}$/.test(cleanNumber);
	};

	confirmSetNumberPatternHandler = async (e) => {
		this.sendMsg(e);
		this.setState({ confirmSetNumberOnPattern: false });
	};

	sendMsg = async (e) => {
		e.preventDefault();
		const { language } = this.props.language;

		try {
			await this.props.active
				.createCustomer('api_whatsapp_enviou_a_primeira_mensagem')
				.catch((err) => err?.msg && message.error(err.msg));

			const metaMsg = this.state.showTemplateLayout
				? await this.buildMsgFromTemplate(language)
				: this.buildMsgFromText(language);

			this.validateRecipients(metaMsg.to, language);

			await this.trySendMessage(metaMsg, language);
		} catch (err) {
			message.error(err.message || err);
		}
	};

	buildMsgFromText(language) {
		const { msg, from, to, files, totalButtons, registerOnChat } = this.state;

		let messageText = msg || '';
		const buttonsText = totalButtons
			.filter((btn) => btn.selected)
			.map((btn) => `#btn:${btn.label}`)
			.join('');

		messageText += buttonsText;

		if (!messageText.trim() && !files?.length) {
			throw language.msg_empty;
		}

		return {
			message: messageText || ' ',
			from,
			to,
			files,
			mobile: false,
			registerOnChat,
		};
	}

	async buildMsgFromTemplate(language) {
		const {
			from,
			to,
			files,
			fromApi,
			selectedTemplate,
			selectedTemplateArray,
			registerOnChat,
			paramsCount,
		} = this.state;

		let paramsArray = [...selectedTemplateArray];

		const headerComponent = selectedTemplate?.components?.find(
			(component) => component.type === 'HEADER',
		);

		if (headerComponent?.format === 'LOCATION' && !headerComponent.location) {
			throw language.location_required;
		}

		if (paramsCount && paramsArray.length !== paramsCount) {
			throw language.empty_parameters;
		}

		paramsArray = paramsArray.map((p) => ({ default: p }));

		if (fromApi === 'dialog') {
			selectedTemplate.components.forEach((component) => {
				switch (component.type) {
					case 'HEADER':
						if (component.format && component.format === 'TEXT') {
							const matches = component.text.match(/{{\s*([\w\d]+)\s*}}/g);

							if (matches && matches.length > 0) {
								if (!component.example) {
									component.example = {};
								}
								if (!component.example.header_text) {
									component.example.header_text = [];
								}

								const newArray = [];
								matches.forEach((placeholder) => {
									const index = parseInt(placeholder.replace('{{', '').replace('}}', ''), 10) - 1;

									if (paramsArray[index]) {
										newArray.push(paramsArray[index].default);
										paramsArray.splice(index, 1);
									}
								});
								component.example.header_text = newArray;
							}
						}
						break;
				}
			});
		}

		return {
			params: paramsArray,
			from,
			to,
			files,
			api: fromApi,
			templateName: selectedTemplate.name,
			templateLanguage: selectedTemplate.language,
			templateComponents: selectedTemplate.components,
			wabaId: selectedTemplate.wabaId || null,
			mobile: false,
			registerOnChat,
		};
	}

	validateRecipients(to, language) {
		if (!to?.length) throw language.to_empty;

		if (this.state.fromApi === 'meta') {
			return;
		}

		to.forEach((num) => {
			if (!this.validatePhoneNumber(num)) throw language.invalid_number;
		});
	}

	resetMessageState = () => {
		this.setState({
			msg: '',
			files: [],
			recordedBlob: null,
			voice_recording: null,
			recording: false,
			listening: false,
			recordButton: <AudioOutlined />,
			recordingButtonAnimation: 'none',
			listeningButtonAnimation: 'none',
			recordingButtonFontSize: '1.5em',
		});
	};

	async trySendMessage(metaMsg, language) {
		let failed = false;

		await this.props.number
			.sendMessage(metaMsg)
			.then((res) => {
				message.success(language.send_message_success);
				if (this.state.registerOnChat && res.status && res.dialog_id) {
					window.BX24.im.openMessenger('chat' + res.dialog_id);
				}
				this.resetMessageState();
			})
			.catch((e) => {
				failed = true;
				this.handleSendError(e, language);
			});

		if (this.state.registerOnChat && failed) {
			message.warning(language.retry_send_message_without_register);
			await this.props.number
				.sendMessage({ ...metaMsg, registerOnChat: false })
				.then(() => {
					message.success(language.send_message_success);
					this.resetMessageState();
				})
				.catch((e) => message.error(e?.msg || language.send_message_unexpected_error));
		}
	}

	handleSendError(e, language) {
		if (this.state.registerOnChat) {
			const suffix = language[e.msg?.toLowerCase()] ? `: ${language[e.msg.toLowerCase()]}` : '';
			return message.error(language.register_on_chat_fail + suffix);
		}
		if (e.msg) return message.error(e.msg);
		if (e.response?.data?.message || e.response?.data?.errorCode) {
			const errorMessage = e.response.data.errorCode || e.response.data.message;
			return message.error(language[errorMessage] || errorMessage);
		}

		if (e.message || e.errorCode) {
			const errorMessage = e.errorCode || e.message;
			return message.error(language[errorMessage] || errorMessage);
		}
		message.error(language.send_message_unexpected_error);
	}

	async componentDidMount() {
		this.setState({
			totalButtons: [
				{ label: this.props.language.language.confirm, selected: false },
				{ label: this.props.language.language.schedule, selected: false },
				{ label: this.props.language.language.no_thanks, selected: false },
				{ label: this.props.language.language.i_want, selected: false },
				{ label: this.props.language.language.no, selected: false },
			],
		});
		window.BX24.init(async () => {
			const auth = window.BX24 ? window.BX24.getAuth() : { domain: 'solinka.bitrix24.com' };
			const domain = auth.domain;

			await this.loadClientInfos(domain);
			await this.getUser(domain);
		});
	}

	async setCloseAlert() {
		const self = this;
		await self.props.system
			.setCloseAlert(this.state.userApp)
			.then((data) => {
				console.log('MessageItem::closeAlert success: ', data.status);
			})
			.catch((e) => {
				console.log('MessageItem::closeAlert error: ', e);
			});
	}

	async getUser() {
		try {
			window.BX24.init(async () => {
				const auth = window.BX24 ? window.BX24.getAuth() : { domain: 'solinka.bitrix24.com' };
				this.setState({ auth });
				const domain = auth.domain;
				const lang = window.BX24 ? window.BX24.getLang() : 'en';

				this.setState({ domain });
				this.setState({ lang });

				await window.BX24.callMethod('user.current', {}, async (res) => {
					let user = res.data();

					user = user || {
						NAME: '',
						EMAIL: '',
						PERSONAL_PHONE: '',
					};

					this.setState({ userApp: user });

					window.BX24.fitWindow();

					return new Promise(async (resolve, reject) => {
						const request = {
							action: 'getUser',
							user: user.ID,
							domain,
						};

						await api.post('getUser', request).then(async (res) => {
							if (res.data.status) {
								if (
									res.data.dados &&
									res.data.dados !== 'Client not found' &&
									res.data.dados !== null
								) {
									this.setState({ closeAlert: res.data.dados.close_alert });
								} else {
									this.setState({ closeAlert: 0 });
								}

								resolve(res.data);
							} else {
								reject(res.data);
							}
						});
					});
				});
			});
		} catch (e) {
			console.log('MessageItem::getUser', {
				Exception: e,
			});
		}
	}

	render() {
		return (
			<>
				<div
					style={{
						border: '1px dashed #e9e9e9',
						backgroundColor: '#fff',
						borderRadius: 6,
						padding: 5,
						textAlign: 'left',
					}}
				>
					{this.state.closeAlert !== 1 && (
						<Row>
							<Col>
								<div style={{ paddingBottom: 5 }}>
									<GoodHabitsAlert
										onClose={() => {
											this.setCloseAlert(this);
										}}
									/>
								</div>
							</Col>
						</Row>
					)}
					<Row style={{ marginBottom: '20px' }}>
						<Col span={24}>
							{!this.props.system.loadingSubscription &&
								!this.props.system.subscriptionError &&
								this.props.system.subscription.status !== 'active' && (
									<div style={{ padding: 5 }}>
										<SubscriptionWarning />
									</div>
								)}
						</Col>
						<Col span={24}>
							<NumberSelectors
								numbers={this.props.number}
								bitrix24={this.props.bitrix24}
								language={this.props.language.language}
								state={this.state}
								setState={this.updateState}
							/>
						</Col>
						<Col span={24}>
							<div style={{ padding: 0, margin: 0 }}>
								<Card>
									{this.state.showTemplateLayout ? (
										<TemplateLayout
											state={this.state}
											setState={this.updateState}
											language={this.props.language.language}
										/>
									) : (
										<MessageLayout
											state={this.state}
											setState={this.updateState}
											language={this.props.language.language}
										/>
									)}
								</Card>
							</div>
						</Col>
						<Col style={{ padding: '16px 0px 0px 16px', marginLeft: '6px' }} span={16}>
							{!this.state.showTemplateLayout &&
								!this.props.number.isWellcomeScreen &&
								this.state.from !== '' && (
									<Skeleton
										active
										paragraph={{ rows: 0 }}
										loading={this.state.loadingVerifyIfChatExistsInEntity}
									>
										<Switch
											loading={this.state.loadingVerifyIfChatExistsInEntity}
											disabled={!this.state.isChatExistsInEntity}
											style={{ marginRight: '4px' }}
											checked={this.state.registerOnChat}
											onChange={this.onChangeSwitch}
										/>
										{this.state.loadingVerifyIfChatExistsInEntity}
										<FormattedMessage id="register_on_chat_switch" />
										{!this.state.isChatExistsInEntity ? (
											<Tooltip
												placement="top"
												title={<FormattedMessage id="register_on_chat_switch_disabled" />}
											>
												{' '}
												<WarningOutlined style={{ color: '#FF9901', fontSize: '16px' }} />
											</Tooltip>
										) : (
											<Tooltip
												placement="top"
												title={
													<FormattedMessage
														id="register_on_chat_switch_alert"
														values={{
															strong: (item) => <strong>{item}</strong>,
														}}
													/>
												}
											>
												{' '}
												<InfoCircleOutlined style={{ color: '#08AAF2', fontSize: '16px' }} />
											</Tooltip>
										)}
									</Skeleton>
								)}
						</Col>
						<Col style={{ padding: '8px 0px 16px 0px' }} span={6}>
							<Popconfirm
								title={this.props.language.language.confirm_set_number_on_pattern}
								visible={this.state.confirmSetNumberOnPattern}
								onConfirm={this.confirmSetNumberPatternHandler.bind(this)}
								onCancel={() => this.setState({ confirmSetNumberOnPattern: false })}
								okText={this.props.language.language.yes}
								cancelText={this.props.language.language.not}
								placement="topRight"
							>
								<Button
									type="link"
									onClick={this.sendMsgHandler.bind(this)}
									loading={this.props.number.loadingSendMessage}
									disabled={
										(this.state.showTemplateLayout && !!this.state.templateListError) ||
										this.state.from === '' ||
										this.state.recording
									}
									style={{
										display: 'inline-block',
										marginRight: '5px',
										padding: '5px 70px',
										backgroundColor:
											this.state.from === ''
												? '#e5e8ef'
												: this.state.from === ''
												? '#e5e8ef'
												: '#bbed21',
										borderRadius: 0,
										textAlign: 'center',
										marginLeft: 10,
										color: '#535c69',
										fontWeight: 600,
										float: 'right',
									}}
								>
									<FormattedMessage id="send_msg" />
								</Button>
							</Popconfirm>
						</Col>
					</Row>
				</div>
			</>
		);
	}
}

export default Bitrix24Consumer(
	ActiveConsumer(NumberConsumer(LanguageConsumer(SystemConsumer(MessageItem)))),
);
